import { ContentEventFindMethod } from "enums";
import useAxios from "./useAxios";

type Variant = "link" | "file" | "article" | "post" | "product";
type Options = {
  contentId: string;
  variant: Variant;
  findMethod?: ContentEventFindMethod;
  click?: boolean;
  view?: boolean;
};

export default function useClickAndView({
  contentId,
  variant,
  findMethod = ContentEventFindMethod.LinksAndOthers,
  view = true,
  click = true,
}: Options) {
  const urls: Record<Variant, Record<"click" | "view", string>> = {
    link: {
      click: "/ContentEvents/link-click",
      view: "/ContentEvents/link-view",
    },
    file: {
      click: "/ContentEvents/user-file-click",
      view: "/ContentEvents/user-file-view",
    },
    article: {
      click: "/ContentEvents/article-click",
      view: "/ContentEvents/article-view",
    },
    post: {
      click: "/ContentEvents/post-click",
      view: "/ContentEvents/post-view",
    },
    product: {
      click: "/ContentEvents/product-click",
      view: "/ContentEvents/product-view",
    },
  };
  const [axios, loading] = useAxios();
  const handleClick = () => {
    const url = urls[variant].click;
    const body = { contentId, findMethod };
    axios.post(url, body);
  };
  const handleView = () => {
    const url = urls[variant].view;
    const body = { contentId, findMethod };
    axios.post(url, body);
  };
  const handler = () => {
    if (click) handleClick();
    if (view) handleView();
  };
  return [handler, loading] as const;
}
